import React from 'react';
import { Card, CardContent, CardMedia, Chip, Grid, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { CountryCodeEnum } from 'features/common/types';
import { HomeCard, HomeTeamView } from './types';

interface HomeCardGridProps {
	cards: HomeCard[];
	country: CountryCodeEnum;
	viewKey: HomeTeamView;
}

export function getHomeCardReactKey(viewKey: HomeTeamView, card: HomeCard): string {
	return `${viewKey}-${card.id}-${card.link}`;
}

const HomeCardItem = ({ card, showUruguayWarning }: { card: HomeCard; showUruguayWarning: boolean }): JSX.Element => {
	const cardContent = (
		<Card sx={{ display: 'flex', flexDirection: 'column', height: '100%', maxWidth: '240' }}>
			<CardMedia component="div" sx={{ padding: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Typography variant="h4">{card.icon}</Typography>
			</CardMedia>
			<CardContent sx={{ flexGrow: 1 }}>
				<Typography variant="subtitle1" component="div">
					{card.title}
				</Typography>
				<Typography variant="body2" color="text.secondary">
					{card.description}
				</Typography>
				{showUruguayWarning && <Chip label="Requiere ambiente Uruguay" size="small" color="warning" sx={{ mt: 1 }} />}
			</CardContent>
		</Card>
	);

	if (card.isExternal) {
		return (
			<a href={card.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
				{cardContent}
			</a>
		);
	}

	return (
		<RouterLink to={card.link} style={{ textDecoration: 'none' }}>
			{cardContent}
		</RouterLink>
	);
};

export const HomeCardGrid = ({ cards, country, viewKey }: HomeCardGridProps): JSX.Element => (
	<Grid container spacing={2} justifyContent="center">
		{cards.map((card) => (
			<Grid item xs={12} sm={6} md={4} lg={3} key={getHomeCardReactKey(viewKey, card)}>
				<HomeCardItem
					card={card}
					showUruguayWarning={Boolean(card.requiresUruguay && country !== CountryCodeEnum.URUGUAY)}
				/>
			</Grid>
		))}
	</Grid>
);
